import { gql } from "@apollo/client";

export const GET_DEDUCTION_VALIDITY_RCAS_LOOKUP = gql`
  query DeductionValidityRcasLookup($deductionTypeId: Int) {
    masterDataDeductionValidityRcasLookup(deductionTypeId: $deductionTypeId) {
      count
      items {
        id
        deductionTypeId
        rcaCode
        rcaDescription
        ruleName
        description
      }
    }
  }
`;
